import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ClientsWorkOverviewRow } from "../clientsWorkOverviewViewConfig";
import { EMPTY_CELL_VALUE } from "./emptyCellValue";

export const WorkUnreadTasksCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, ClientsWorkOverviewRow, number>) => {
        if (row.original.rowType !== "work") {
            return EMPTY_CELL_VALUE;
        }
        const count = row.original.unreadTaskCount ?? 0;
        if (count === 0) {
            return EMPTY_CELL_VALUE;
        }
        return <ViewTableCell>{count}</ViewTableCell>;
    },
);
WorkUnreadTasksCell.displayName = "WorkUnreadTasksCell";
